<div class="flex-container">
  <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
          <thead>
              <tr style="text-align-last: center;">
                  <th class="right-align schematicName">{{schematicDetails.Name}}</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>
                      <app-schematic-observation-points [SchematicOP]="ObservationPointDetails" [schematicData]="schematicDetails" style="position: relative; " [isCrack]="1" [ImplementId]="ImplementId"></app-schematic-observation-points>
                </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div class="panel__content no-padding">
      <table class="table table--striped table--full-width" >

          <thead>
              <tr>
                  <th style="padding: 16px 24px;text-align: left;" >Component</th>
                  <th style="padding: 16px 24px;text-align: left;">Observation Point</th>
                  <th style="text-align: center; padding: 16px 24px;text-align: center;">OP Type</th>
                  <th style="text-align: center; padding: 16px 24px;text-align: center;">Worn %</th>
                  <ng-container *ngIf="headerAction!=null">
                    <ng-container *ngFor="let item of headerAction">
                        <th style="padding: 16px 24px;text-align: left;">
                          <div style="display: flex;flex-direction: column;text-align: center;">
                        
                            <span  *ngIf="item.isComponentAction!=0"  style="cursor: pointer;" class="material-icons" (click)="OpenReplaceRepairAction(item)">
                                build_circle
                                </span>
                              <span> {{item.Action}}</span>
                              <span> {{item.ActionDate|date: 'dd MMM yyyy'}} </span>
                          </div>
                      </th>
                    </ng-container>
                  </ng-container>
                  
                 
              </tr>
          </thead>
          <tbody>
              <ng-container *ngIf="ObservationPointDetails!=null">
                <ng-container *ngFor="let OP of ObservationPointDetails">
                    <tr (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                        <td class=" columncell" title="{{OP.ComponentName}}">{{OP.ComponentName}}</td>
                        <td class=" columncell" title="{{OP.Name}}">{{OP.Name}}</td>
                        <td style="text-align: center;" class=" columncell_" *ngIf="OP.Type == 'Crack'" >
                            <ng-container >
                                <div [ngStyle]="{ 'background-color': OP.ColorCode || '#e4351d' }" 
                                class="crack-status-badge" matTooltip="{{OP.CrackStatus}}">
                                    {{OP.Type}}
                                </div>
                            </ng-container>
                        
                        </td>
                        <td  class=" columncell_"style="text-align: center;"  *ngIf="OP.Type != 'Crack'"> {{OP.Type}}</td>
                        <td  style="cursor: pointer;">
                          <ng-container *ngIf="OP.Eval == ''">
                              <div class="{{getEvalClass(OP.WornPct)}}">
                                  {{OP.WornPct}}%
                              </div>
                          </ng-container>
                          <ng-container *ngIf="OP.Eval != ''">
                              <div class="{{getEvalClass2(OP.Eval)}}">
                                  {{OP.Eval}}
                              </div>
                          </ng-container>
                      </td>
                      <ng-container *ngIf="OP.ObsActionHistroy!=null">
                          <ng-container *ngFor="let item of OP.ObsActionHistroy">
                            <td  style="cursor: pointer;" *ngIf="item.isComponentAction==0">
                                <ng-container *ngIf="OP.Eval == ''">
                                    <div *ngIf="item.WornPercent!=null" class="{{getEvalClass(item.WornPercent)}}">
                                        {{item.WornPercent}}%
                                    </div>
                                    <div *ngIf="item.WornPercent==null" class="WornPctCell noEval">
                                        N/A
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="OP.Eval != ''">
                                    <div class="{{getEvalClass2(item.Eval)}}">
                                        {{item.Eval}}
                                    </div>
                                </ng-container>
                            </td>
                            <td style="cursor: pointer;text-align: center;" *ngIf="item.isComponentAction!=0">
                                <ng-container *ngIf="OP.ComponentId == item.CompId">
                                    <span class="material-icons">
                                        build_circle
                                        </span>
                                </ng-container>
                            </td>
                          </ng-container>
                      </ng-container>
                    </tr>
                </ng-container>
              </ng-container>
          </tbody>
      </table>
  </div>
</div>